<template>

  <div>
    <SignupComponent @signup-success="onSignupSuccess" v-if="!showTour">
      <LoginHeader>
        <div class="level-item">
          Already registered?
        </div>
        <div class="level-item">
          <router-link :to="{'name': 'users_login'}" class="button">Log in</router-link>
        </div>
      </LoginHeader>


      <template v-slot:title>
        <h3 class="title login-title ">Sign up for free</h3>
        <div class="sep-32"></div>
        <div>
          <GoogleLogin :is-signup="true"></GoogleLogin>
        </div>
        <!--          <div class="sep-16"></div>-->
        <!--          <div>-->
        <!--            <FacebookLogin :is-signup="true"></FacebookLogin>-->
        <!--          </div>-->
        <div class="sep-32"></div>
        <div class="gray-sep"></div>
        <div class="sep-32"></div>
      </template>
    </SignupComponent>
    <div v-if="showTour">
      <Report is-demo="showTour" :demo-report-id="demoReportId"></Report>
    </div>
  </div>


</template>

<script>
import LoginHeader from "../../../shared/components/LoginHeader";
import GoogleLogin from "../components/GoogleLogin";
import FacebookLogin from "../components/FacebookLogin";
import SignupComponent from "@/modules/login/components/SignupComponent";
import Report from "@/modules/calculator/containers/report"
import {config} from '@/config/config';
import {mapGetters} from "vuex";
import introJs from "intro.js"
export default {
  props: {},
  components: {SignupComponent, LoginHeader, GoogleLogin, FacebookLogin, Report},
  data() {
    return {
      formData: {},
      loading: false,
      showTour: false,
      selectedPlan: null,
      demoReportId: config('DEMO_REPORT_ID'),
    }
  },
  async mounted() {

    this.selectedPlan = this.$route.params.priceId;
    $('body').on('click', '#demo-next', () => {
      this.goNext();
    });

    try {
      await this.$store.dispatch('updateUserData')
      if(this.isLoggedIn){
        this.showTour = true;
        this.pingTour();
      }
    } catch (e) {

    }

    if(this.isInvestorSignup) {
      window.localStorage.setItem('isInvestor', '1');
    }
  },
  methods: {
    onSignupSuccess(){

      /* typeof gtag !== "undefined"? gtag('event', 'conversion', {
        'send_to': 'AW-408551170/AljdCNvIpfECEIL-58IB',
        'event_callback': function(){}
      }): null; */
      if (this.$route.query.redirectTo === 'shared_reports') {
        this.goNext();
      } else {
        this.showTour = true;
        this.pingTour();
      }
    },
    goNext(){
      if(this.$route.query.redirectTo) {
        this.$router.push({
          name: 'shared_reports'
        });
      }
      else if(this.isInvestorSignup){
        this.$router.push({
          name: 'investor-profile',
          query: this.selectedPlan? {
            priceId: this.selectedPlan
          }: {}
        });
      }
      else {
        this.$router.push({
          name: 'startup-profile',
          query: this.selectedPlan? {
            priceId: this.selectedPlan
          }: {}
        });
      }
    },
    pingTour(){
      setTimeout(() => {
        introJs().setOptions({
          tooltipClass: 'startupfalcon-intro',
          steps: [{
            position: 'left',
            element: document.querySelector('.layout-title'),
            title: 'How about you jump on a quick product tour?',
            intro: 'This is a demo of the results you will get once you finish your valuation.'
          },
            {
              element: document.querySelector('#report-profile'),
              intro: 'Your profile information will be shown here.'
            },
            {
              element: document.querySelector('#premoney-valuation'),
              intro: 'This is your final valuation using the four methods.'
            },
            {
              element: document.querySelector('#pdf-report'),
              intro: 'You can download the detailed valuation report from here.'
            },
            {
              element: document.querySelector('#four-methods'),
              intro: 'Per method valuation summary will be shown here.'
            },
            {
              element: document.querySelector('#startup-information'),
              intro: 'This section is part of your startup summary, which contains descriptive information about your startup.'
            },
            {
              element: document.querySelector('#methods-breakdown'),
              intro: 'Here is the detailed valuation from each method.'
            },
            {
              element: document.querySelector('#statistics'),
              intro: 'Here is the benchmarking data that you need to support your valuation.'
            },
            {
              intro: 'Start Your Valuation Now!'
            }]
        }).start();
      }, 1000)
    }
  },
  destroyed() {
    clearInterval(window.tourInterval);
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    isInvestorSignup() {
      return this.$route.name === 'users_signup_investor';
    }
  }
};
</script>

<style lang="scss" scoped>
.agreement-checkbox {
  width: 25px;
  text-align: center;
  flex: none;

  input {
    position: relative;
    top: 10px;
  }
}
</style>
